import { Box, FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { FC } from 'react';
import { TStep3SquarespaceProps } from './types';

export const Step3Squarespace: FC<TStep3SquarespaceProps> = ({
	APIKey,
	setAPIKey,
	storeAddress,
	setStoreAddress,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: { xs: 'column', sm: 'row' },
				justifyContent: 'space-between',
				width: '100%',
				gap: '20px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'left',
					gap: '20px',
					width: '100%',
				}}
			>
				<FormControl size="small" sx={{ width: '100%' }}>
					<InputLabel htmlFor="store-address">Store Address</InputLabel>
					<OutlinedInput
						sx={{
							borderRadius: '12px',
						}}
						id="store-address"
						label="Store Address"
						size="small"
						value={storeAddress}
						onChange={(e) => setStoreAddress(e.target.value)}
					/>
					<FormHelperText id="store-address-helper-text">
						your store website address for the customers
					</FormHelperText>
				</FormControl>
				<FormControl size="small" sx={{ width: '100%' }}>
					<InputLabel htmlFor="api-key">API Key</InputLabel>
					<OutlinedInput
						id="api-key"
						sx={{
							borderRadius: '12px',
						}}
						label="API Key"
						size="small"
						value={APIKey}
						onChange={(e) => setAPIKey(e.target.value)}
					/>
					<FormHelperText id="api-key-helper-text">
						API key generated in your Squarespace account settings
					</FormHelperText>
				</FormControl>
			</Box>
		</Box>
	);
};
